import { fg } from '@confluence/feature-gating';

export const DEPRECATED_MACROS: string[] = [
	'chart',
	'contributors-summary',
	'gallery',
	'google-drive-docs', // Google Drive for Confluence macros
	'google-drive-sheets',
	'google-drive-slides',
	'index', // Page Index
	'viewppt', // PowerPoint macro
	'viewdoc', // Word macro
	'recently-updated-dashboard',
	'related-labels',
	'spaces', // Spaces List
	'span',
];

export const MACRO_DEPRECATION_INFO_URL =
	'https://support.atlassian.com/confluence-cloud/docs/learn-which-macros-are-being-removed/';

// TODO: remove this code when cleaning up deprecating_low_usage_macros FG after macro removal on Sep 25 2025
export const isMacroDeprecated = (extensionKey: string): boolean => {
	// eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
	if (DEPRECATED_MACROS.includes(extensionKey) && fg('deprecating_low_usage_macros')) {
		switch (extensionKey) {
			case 'chart':
				// eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
				return fg('confluence_deprecate_chart_macro');
			case 'contributors-summary':
				// eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
				return fg('confluence_deprecate_contributors_summary');
			case 'gallery':
				// eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
				return fg('confluence_deprecate_gallery_macro');
			case 'google-drive-docs':
				// eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
				return fg('confluence_deprecate_google_drive_macro');
			case 'google-drive-sheets':
				// eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
				return fg('confluence_deprecate_google_drive_macro');
			case 'google-drive-slides':
				// eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
				return fg('confluence_deprecate_google_drive_macro');
			case 'index':
				// eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
				return fg('confluence_deprecate_page_index_macro');
			case 'viewppt':
				// eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
				return fg('confluence_deprecate_powerpoint_macro');
			case 'viewdoc':
				// eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
				return fg('confluence_deprecate_word_macro');
			case 'recently-updated-dashboard':
				// eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
				return fg('confluence_deprecate_recently_updated_dashboard');
			case 'related-labels':
				// eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
				return fg('confluence_deprecate_related_labels_macro');
			case 'spaces':
				// eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
				return fg('confluence_deprecate_spaces_list_macro');
			case 'span':
				// eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
				return fg('confluence_deprecate_span_macro');
			default:
				return false;
		}
	}
	return false;
};
